module.exports = __webpack_public_path__ + "img/firm.99ee006b.png";